import { render, staticRenderFns } from "./ConfirmUserAddress.vue?vue&type=template&id=3080731f&scoped=true&"
import script from "./ConfirmUserAddress.vue?vue&type=script&lang=js&"
export * from "./ConfirmUserAddress.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmUserAddress.vue?vue&type=style&index=0&id=3080731f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3080731f",
  null
  
)

export default component.exports